import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import type { IOrderMessage, IOrderMessages } from '@interfaces/orderMessage';

export interface IOrderMessagesState extends IOrderMessages {}

export const INITIAL_STATE: IOrderMessagesState = {
	metadata: {
		page: 0,
		pageLimit: 0,
		count: 0,
	},
	result: [],
};

@Injectable({
	providedIn: 'root',
})
export class OrderMessagesStore {
	private _orderMessagesState = new BehaviorSubject<IOrderMessagesState>(
		INITIAL_STATE
	);
	readonly orderMessagesState$ = this._orderMessagesState.asObservable();

	constructor() {}

	updateOrderMessages(orderMessages: IOrderMessagesState) {
		const state = this._orderMessagesState.value;

		let newResult = [];

		// se page === 1 → substitui tudo
		if (orderMessages.metadata.page === 1) {
			newResult = orderMessages.result ?? [];
		}
		// se page > 1 → add no topo
		else {
			newResult = [...(orderMessages.result ?? []), ...(state.result ?? [])];
		}

		const data: IOrderMessagesState = {
			metadata: orderMessages.metadata,
			result: newResult,
		};

		this._orderMessagesState.next(data);
	}

	updateOrderMessage(orderMessage: IOrderMessage) {
		const state = this._orderMessagesState.value;

		const orderMessageIndex = state.result.findIndex(
			({ id }) => id === orderMessage.id
		);

		if (orderMessageIndex >= 0) {
			state.result[orderMessageIndex] = {
				...state.result[orderMessageIndex],
				...orderMessage,
			};
		} else {
			state.result.push(orderMessage);
		}

		const data = state;

		this._orderMessagesState.next(data);

		return this._orderMessagesState.asObservable();
	}

	deleteOrderMessage(orderMessage: IOrderMessage) {
		const state = this._orderMessagesState.value;

		const orderMessageIndex = state.result.findIndex(
			({ id }) => id === orderMessage.id
		);

		state.result.splice(orderMessageIndex, 1);

		const data = state;

		this._orderMessagesState.next(data);

		return this._orderMessagesState.asObservable();
	}
}
